import { observable, computed, action } from "mobx"; // set, toJS
import { Hand } from "./Hand";
import { comm } from "../../comm";
import { store } from "../mainStore";

export class Match {
	@observable matchId = null;
	@observable round = 0;
	@observable opponent = {
		id: null,
		name: '',
		hasCompletedRolls: false,
		hands: [],
		image: '',
		currentRound: 0
	};
	@observable type = '1v1';
	@observable goals = [];

	@observable handNumber = 1;
	@observable hands = [];

	@observable currentHand = null;
	@observable status = 0;
	@observable state = '';

	@observable complete = false;

	@observable roundCount = 3;

	@observable fromResume = false;
	@observable canApplyFreeroll = false;
	@observable canApplyHandReset = false;

	@computed get goal(){
		return this.goals[this.goals.length - 1];
	}

	@observable rounds = [];

	constructor(matchData, mode, network) {
		if(network){
			this.matchId = matchData.Id;
			this.status = matchData.UserCurrentRound;
			this.round = matchData.UserCurrentRound;
			this.handNumber = matchData.UserCurrentRound;

			this.canAcceptChallenge = matchData.CanAcceptChallenge;
			this.isStartHand = matchData.IsStartHand;
			this.canRollDice = matchData.CanRollDice;
			this.canApplyFreeroll = matchData.CanApplyFreeroll;
			this.freeRollCost = matchData.FreeRollCost;
			this.userFreeRolls = matchData.UserFreeRolls;
			this.userFreeRollsUsed = matchData.UserFreeRollsUsed;
			this.canApplyHandReset = matchData.CanApplyHandReset;
			this.canKeepHand = matchData.CanKeepHand;
			this.canResignMatch = matchData.CanResignMatch;
			this.canClaimReward = matchData.CanClaimReward;

			this.playerCount = matchData.PlayerCount;
			this.creatorId = matchData.CreatorId;

			store.currentStake = matchData.Bid && matchData.Bid > 0 ? matchData.Bid : 50;
			store.currentPot = matchData.Pot ? matchData.Pot : 0;

			if(matchData.Opponents.length === 0){
				this.opponent = {
					id: 0,
					name: 'unknown',
					image: '',
					currentRound: 1,
					hands: [],
					level: 0
				}
			} else {
				let opp = matchData.Opponents[0];
				this.opponent = {
					id: opp.UserId,
					name: opp.DisplayName || opp.Username,
					isBot: opp.IsBot,
					image: opp.ImageUrl,
					botKey: opp.Username,
					currentRound: opp.CurrentRound,
					hands: [],
					level: opp.summary ? opp.summary.Level : 0
				}
			}

			this.rounds = matchData.Rounds;
			this.roundCount = matchData.RoundCount;

			this.goals.replace(matchData.Rounds.map(r => window.manager.hands[r.TargetHand]));
			var heartsUsed = 0;
			matchData.UserMatchRounds.forEach((round) => {
				this.hands.push(new Hand(round, true));
				if(round.Rolls.length > 3){
					heartsUsed += round.Rolls.length - 3;
				}
			})
			this.hearts = matchData.UserFreeRolls - heartsUsed;
			if(matchData.Opponents.length && matchData.Opponents[0].MatchRounds){
				matchData.Opponents[0].MatchRounds.forEach(round => {
					//if(round.State > 2){
						this.opponent.hands.push(new Hand(round, true));
					//}
				});
			}
			this.currentHand = this.hands[this.hands.length - 1];
			this.state = matchData.State;
			this.userState = matchData.UserState;
			this.needToAcceptChallenge = matchData.UserState === 'pe';
			this.type = matchData.Type;

			//the player is returning for the first hand of a new round and the opponent has results to show and the player is the initiator of the match
			this.shouldShowScorecardFirst = this.hands.length % 3 === 1 && this.opponent.hands.length > 0 && this.hands.length > this.opponent.hands.length
		} else {
			Object.assign(this, matchData);
		}
	}

	@action useHeart(){
		// this.hearts += -1;
		store.skillzHearts += -1; //using Rob's special subtraction technique :)
		this.currentHand.rollsRemaining = 1;
	}
	@action useHandReset(){
		// this.hearts += -1;
		store.skillzHearts += -store.resetHandCost; //using Rob's special subtraction technique :)
		this.currentHand.rollsRemaining = 3;
	}

	@action start(){}

	@action nextHand(){
		console.log('MATCH nextHand :: ch =', this.currentHand)
		return new Promise((resolve, reject) => {
			var hasOpponentData = this.PollForOpponentData();

			if(store.activeMatch.currentHand.complete){
				hasOpponentData.then(resolve);
			} else {
				comm.CompleteHand(store.activeMatch.matchId, store.activeMatch.currentHand.heldIndexes)
				.then(() => {
					hasOpponentData.then(resolve).catch(reject);
				});
			}
		})
		.then(() => {
			return store.updateMatch()
			.then(() => {
				this.currentHand.complete = true;
				this.currentHand = new Hand();
				this.hands.push(this.currentHand);
				this.handNumber++;
				this.status++;
			});
		});
	}

	PollForOpponentData = () => {
		return new Promise((resolve, reject) => {
			(function poll(){
				if(store.activeMatch.handNumber % 3 !== 0){
					resolve();
				} else {
					setTimeout(() => {
						store.updateMatch()
						.then(resolve)
						.catch(reject);
					}, 1000);
				}
			})();
		});
	}

	@action updateFromNetwork(match){
		if(this.hands.length === 0) {
			var heartsUsed = 0;
			match.UserMatchRounds.forEach((round) => {
				this.hands.push(new Hand(round, true));
				if(round.Rolls.length > 3){
					heartsUsed += round.Rolls.length - 3;
				}
			})
			this.hearts = match.UserFreeRolls - heartsUsed;
			this.currentHand = this.hands[this.hands.length - 1];
		} else {
			this.goals.replace(match.Rounds.map(r => window.manager.hands[r.TargetHand]));
			this.hands.forEach((hand, i) =>
				hand.updateFromNetwork(match.UserMatchRounds[i]));
		}

		this.round = this.goals.length;

		this.canApplyFreeroll = match.CanApplyFreeroll;
		this.canApplyHandReset = match.CanApplyHandReset;
		store.currentStake = match.Bid && match.Bid > 0 ? match.Bid : 50;
		store.currentPot = match.Pot ? match.Pot : 0;

		if(match.Opponents.length && match.Opponents[0].MatchRounds){
			let opHands = [];
			match.Opponents[0].MatchRounds.forEach((round) => {
				// if(round.State > 2){
					const oppHand = new Hand(round, true);
					oppHand.adjustOpponentHand(round);
					opHands.push(oppHand);
				// }
			});
			this.opponent.hands.replace(opHands);
		}
		this.opponent.currentRound = 0;

		if(match.Opponents.length && match.Opponents[0].MatchRounds.length){
			this.opponent.currentRound = match.Opponents[0].MatchRounds.length;
		}

		this.state = match.State;
		this.userState = match.UserState;
		this.type = match.Type;
		this.complete = match.State === 'co';
	}

}
